<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <div class="flex-grow-1" style="max-width: 438px;">
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Meedoen coach</h1>

      <base-card class="flex-grow-1" inner-class="container d-flex" color="alternate" :outer-padding="true">
        <base-form @submit="onSubmit" class="w-100">

          <base-input
            type="radiobuttons" 
            :options="bellerLoperOptions"
            name="bellerLoper" 
            direction="column"
            v-model:value="lead.bellerLoper.Naam" 
            :validator="v$.bellerLoper.Naam"
            force-validation-state="neutral"
          >
          </base-input>

          <button-row class="mt-5">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="v$.bellerLoper.$invalid">Volgende</base-button>
          </button-row>
        </base-form>
      </base-card>

      <button-row class="mt-2">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"

  import { useAllStores } from "@/helpers/UseAllStores";
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    computed: {
      bellerLoperOptions() {
        return [
          // { label: 'Constantijn Blaauwhof', value: 'Constantijn Blaauwhof' },
          // { label: 'Samme Guarnieri', value: 'Samme Guarnieri' },
          // { label: 'Yarnick Kleine', value: 'Yarnick Kleine' },
          // { label: 'Jente Thomson', value: 'Jente Thomson' },
          // { label: 'Levi Adema', value: 'Levi Adema' },
          // { label: 'Niels Grozema', value: 'Niels Grozema' },
          // { label: "Lennard Kooistra", value: "Lennard Kooistra"},
          { label: 'Tom Gerrits', value: 'Tom Gerrits' },
          // { label: 'Noël Dounato', value: 'Noël Dounato' },
          // { label: 'Jorn Offens', value: 'Jorn Offens' },
          { label: 'Wietse Kloosterman', value: 'Wietse Kloosterman' },
          { label: 'Matthijs Kroon', value: 'Matthijs Kroon' },


            { label: 'Jorn Dijk', value: 'Jorn Dijk' },
            { label: 'Sia Dijkstra', value: 'Sia Dijkstra' },
            { label: 'Mart van der Veen', value: 'Mart van der Veen' },
            { label: 'Raymond Nijdam', value: 'Raymond Nijdam' },
            { label: 'Lina Sue', value: 'Lina Sue'},

          // { label: 'werkgroep PEP-5', value: 'werkgroep PEP-5' },
          
        ];
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.bellerLoper.$touch();
        return !this.v$.bellerLoper.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    }
  }
</script>
